// Firebase Authentication JWT Schema
// The JWT may contain state values pertinent to application rendering
// They are defined here

/**
 * Subscription status values that determine user access and billing state.
 * These statuses are managed by the backend and reflected in the JWT claims.
 */
export enum SubscriptionStatus {
  // No subscription - occurs between initial signup and stripe customer creation (transitions to PRE_TRIAL once created)
  // Also the default fallback if the subscription_status in JWT is missing or undefined
  NONE = 'none',
  // Pre-trial state - user signed up, stripe customer has been created, but hasn't completed checkout to start trial
  PRE_TRIAL = 'pre_trial',
  // Active trial period - user has full access during trial, converts to PAID at trial end or EXPIRED if they cancel before trial end
  TRIAL = 'trial',
  // Active paid subscription - user has full access with billing
  PAID = 'paid',
  // Trial or subscription has expired - user loses access and needs to resubscribe
  EXPIRED = 'expired',
  // User account has been deleted - no longer accessible
  DELETED = 'deleted',
  // Organization-based access - user belongs to an organization
  ORGANIZATION = 'organization',
  // Internal/engineering access - bypasses normal subscription flow, no Stripe subscription required
  PAXTON = 'paxton',
  // Partner organization access - used partner code to gain access, no Stripe subscription required
  PARTNER = 'partner',
}

export enum SurveyStatus {
  NONE = 'none',
  COMPLETED = 'completed',
}

export enum InferredPollingState {
  NONE = 'none',
  POLL_SUBSCRIPTION = 'poll_subscription',
  POLL_PAYMENT = 'poll_payment',
}

export enum BillingCycle {
  MONTHLY = 'monthly',
  ANNUAL = 'annual',
}

export enum BrandEnum {
  NONE = 'none',
  PAXTON = 'paxton',
  HAIKU = 'haiku',
}
